module.exports = __webpack_public_path__ + "img/eat_out_24.293e2e89.jpg";